import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Image as ImageIcon, Sparkles, Brush, Palette, Layers } from 'lucide-react';
export function Coloring() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="pt-32 pb-24 bg-white min-h-screen" data-id="element-271">
      <div className="container mx-auto px-6 md:px-12" data-id="element-272">
        {/* HERO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center mb-20" data-id="element-273">
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-ink mb-6" data-id="element-274">
            Фарбування
          </h1>
          <p className="text-muted text-lg md:text-xl font-normal leading-relaxed" data-id="element-275">
            Балаяж, шатуш, аіртач та класичне фарбування — підбираємо відтінок,
            що підкреслить вашу природну красу.
          </p>
        </motion.div>

        {/* SERVICE TYPES */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-276">
          {[{
          icon: <Sparkles size={24} strokeWidth={1.5} data-id="element-277" />,
          title: 'Балаяж та Шатуш',
          desc: 'Плавні переходи кольору для натурального ефекту'
        }, {
          icon: <Brush size={24} strokeWidth={1.5} data-id="element-278" />,
          title: 'Аіртач',
          desc: "Техніка розпилення для м'якого градієнту"
        }, {
          icon: <Palette size={24} strokeWidth={1.5} data-id="element-279" />,
          title: 'Класичне фарбування (тон в тон)',
          desc: 'Рівномірне перекриття кольору по всій довжині'
        }, {
          icon: <Layers size={24} strokeWidth={1.5} data-id="element-280" />,
          title: 'Меліровання',
          desc: "Освітлення окремих прядей для об'єму та сяяння"
        }].map((item, i) => <div key={i} className="bg-white p-8 rounded-[2rem] border border-line shadow-sm flex flex-col items-center text-center" data-id="element-281">
              <div className="text-ink mb-6 p-4 bg-surface rounded-full border border-line" data-id="element-282">
                {item.icon}
              </div>
              <h3 className="text-lg font-semibold text-ink mb-3" data-id="element-283">
                {item.title}
              </h3>
              <p className="text-sm text-muted leading-relaxed" data-id="element-284">{item.desc}</p>
            </div>)}
        </motion.div>

        {/* PRICE SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-4xl mx-auto mb-24" data-id="element-285">
          <div className="text-center mb-12" data-id="element-286">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-287">
              Прайс
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-288"></div>
          </div>

          <div className="grid md:grid-cols-2 gap-12" data-id="element-289">
            {/* TAB 1 */}
            <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-290">
              <h3 className="text-xl font-semibold text-ink mb-2" data-id="element-291">
                Фарбування тон в тон
              </h3>
              <p className="text-xs text-muted mb-6 pb-4 border-b border-line" data-id="element-292">
                *Ціна вказана без урахування матеріалу
              </p>
              <ul className="space-y-4" data-id="element-293">
                {[{
                name: 'Коріння',
                price: '200 грн'
              }, {
                name: 'Коротка стрижка',
                price: '250 грн'
              }, {
                name: 'До середини шиї',
                price: '300 грн'
              }, {
                name: 'До плечей',
                price: '350 грн'
              }, {
                name: 'Нижче плечей',
                price: '400 грн'
              }, {
                name: 'Нижче лопаток',
                price: '450 грн'
              }, {
                name: 'До пояса',
                price: '500 грн'
              }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-294">
                    <span className="text-muted" data-id="element-295">{item.name}</span>
                    <span className="font-semibold text-ink" data-id="element-296">{item.price}</span>
                  </li>)}
              </ul>
            </div>

            {/* TAB 2 */}
            <div className="bg-surface p-8 rounded-[2rem] border border-line" data-id="element-297">
              <h3 className="text-xl font-semibold text-ink mb-2" data-id="element-298">
                Меліровання
              </h3>
              <p className="text-xs text-muted mb-6 pb-4 border-b border-line" data-id="element-299">
                *Ціна вже включає вартість матеріалу
              </p>
              <ul className="space-y-4" data-id="element-300">
                {[{
                name: 'Зона маківки',
                price: '650–700 грн'
              }, {
                name: 'До середини шиї',
                price: '1300–1500 грн'
              }, {
                name: 'До плечей',
                price: '1600–1800 грн'
              }, {
                name: 'Нижче плечей',
                price: '1800–2000 грн'
              }, {
                name: 'Нижче лопаток',
                price: '2000–2300 грн'
              }, {
                name: 'До пояса',
                price: '2500–3000 грн'
              }].map((item, i) => <li key={i} className="flex justify-between items-center text-base" data-id="element-301">
                    <span className="text-muted" data-id="element-302">{item.name}</span>
                    <span className="font-semibold text-ink" data-id="element-303">{item.price}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </motion.div>

        {/* PORTFOLIO SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-24" data-id="element-304">
          <div className="text-center mb-12" data-id="element-305">
            <h2 className="font-heading text-3xl font-semibold text-ink mb-4" data-id="element-306">
              Мої роботи
            </h2>
            <div className="w-12 h-1 bg-ink mx-auto rounded-full" data-id="element-307"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-308">
            {[1, 2, 3].map(i => <div key={i} className="aspect-[3/4] bg-surface rounded-[2rem] border border-line flex items-center justify-center shadow-sm" data-id="element-309">
                <div className="text-center flex flex-col items-center" data-id="element-310">
                  <ImageIcon className="text-muted mb-3" size={32} strokeWidth={1.5} data-id="element-311" />
                  <p className="text-xs text-muted font-medium tracking-widest uppercase" data-id="element-312">
                    Фото роботи
                  </p>
                </div>
              </div>)}
          </div>
        </motion.div>

        {/* CTA SECTION */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-md mx-auto flex flex-col gap-4" data-id="element-313">
          <a href="/#contact" className="w-full py-4 bg-ink text-white text-center text-sm font-medium tracking-wide rounded-full hover:bg-black transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-314">
            Записатися
          </a>
          <Link to="/#services" className="w-full py-4 border border-line text-ink text-center text-sm font-medium tracking-wide rounded-full hover:bg-surface transition-all duration-300" data-id="element-315">
            До всіх послуг
          </Link>
        </motion.div>
      </div>
    </main>;
}